
import {useState,useEffect} from 'react'
import {useNavigate} from "react-router-dom";

//import GetCode from "./GetCode";

function GetPhone ({socket}){
  const [phone,setPhone] = useState ("");
  const navigate = useNavigate ();
  useEffect (()=>{
    if (!socket)return;
    socket.on ('message',(data)=>{

          if (JSON.parse(data).verify==false)window.alert(JSON.parse(data).text)
          else if (JSON.parse(data).verify==true)
          {
            window.alert (JSON.parse(data).text);
            navigate ("/GetCode",{state:{phone:JSON.parse(data).phone}});
          }
      });
//    socket.on ('message',(data)=>{
//      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
//      if (data.event==='code_send') window.alert(data.data);
//    });
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
      <div style={style.content}>
        <h2 style={style.text}>
          لطفا شماره تلفن را وارد نماببد
        </h2>
        <input style={style.input}
        type="tel"
        placeholder = "09xxxxxxxxx"
        value={phone}
        onChange = {(e)=>{setPhone (e.target.value)}}/>
      <button style={style.button}
        onClick ={()=>{
          socket.emit ('myPhone',{"phone":phone});

        }}>
         ارسال
      </button>
    </div>
    </div>
  );


}
const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default GetPhone;
